import { render, staticRenderFns } from "./popup_option.vue?vue&type=template&id=1d6c431f&lang=pug"
import script from "./popup_option.vue?vue&type=script&lang=js"
export * from "./popup_option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports